import React from "react";
import PropTypes from "prop-types";
import { responseStatus } from "../../locales/en";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div>{responseStatus.errorText}</div>;
    }

    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node
};

export default ErrorBoundary;
